import { jsx as a, Fragment as s, jsxs as k } from "react/jsx-runtime";
import "react";
import { ImageCard as y } from "../ImageCard/ImageCard.js";
import { AdjustableTwoColumnGrid as T } from "../AdjustableTwoColumnGrid/AdjustableTwoColumnGrid.js";
import { Concat as u } from "../Concat/Concat.js";
import { StringList as o } from "../StringList/StringList.js";
import { ShowAboutContent as h } from "../ShowAboutContent/ShowAboutContent.js";
import { getHoursMinsStr as x, classes as c } from "../../utils/helpers.js";
import '../../assets/ShowAboutLayout.css';const i = {
  "series-about-tab": "_series-about-tab_cekq9_1",
  "slide-up": "_slide-up_cekq9_1"
};
function q({
  series: t,
  type: e = "series",
  showUpcoming: p = !1,
  nextAirdates: g = [],
  firstColumnWidth: b = "33%",
  socialShare: n = {
    enabled: !1,
    url: "",
    text: "",
    longtext: ""
  }
}) {
  var l, m;
  const d = t.cast.map((f) => f.real_name).join(", "), _ = t != null && t.run_time ? x(t.run_time) : "", r = e === "series" ? ["TV Series", t.rating] : [t != null && t.year_released ? t == null ? void 0 : t.year_released : "Film", t.rating, _];
  return console.log("social share in ShowAboutLayout: ", n), /* @__PURE__ */ a(s, { children: /* @__PURE__ */ k(T, { classname: c([i["series-about-tab"], "series-about-tab"]), firstColumnWidth: b, children: [
    t.detailImage === null ? /* @__PURE__ */ a(u, { list: [
      typeof t.genres == "string" ? t.genres : /* @__PURE__ */ a(o, { list: t.genres, separatorType: "comma", makeBlock: !0 }),
      /* @__PURE__ */ a(o, { list: r, separatorType: "pipe", makeBlock: !0 })
    ] }) : /* @__PURE__ */ a(
      y,
      {
        image: {
          url: (l = t.detailImage) == null ? void 0 : l.url,
          aspectRatio: (m = t.detailImage) == null ? void 0 : m.aspectRatio
        },
        content: /* @__PURE__ */ a(u, { list: [
          typeof t.genres == "string" ? t.genres : /* @__PURE__ */ a(o, { list: t.genres, separatorType: "comma", makeBlock: !0 }),
          /* @__PURE__ */ a(o, { list: r, separatorType: "pipe", makeBlock: !0 })
        ] })
      }
    ),
    /* @__PURE__ */ a("div", { className: c([i["series-about-tab__content"], "series-about-tab__content"]), children: /* @__PURE__ */ a(
      h,
      {
        series: t,
        showUpcoming: p,
        castStr: d,
        type: e,
        nextAirDates: g,
        socialShare: n
      }
    ) })
  ] }) });
}
export {
  q as ShowAboutLayout,
  q as default
};
